/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./error404.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./error404.component";
var styles_Error404Component = [i0.styles];
var RenderType_Error404Component = i1.ɵcrt({ encapsulation: 0, styles: styles_Error404Component, data: {} });
export { RenderType_Error404Component as RenderType_Error404Component };
export function View_Error404Component_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" error404 works!\n"]))], null, null); }
export function View_Error404Component_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-error404", [], null, null, null, View_Error404Component_0, RenderType_Error404Component)), i1.ɵdid(1, 114688, null, 0, i2.Error404Component, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var Error404ComponentNgFactory = i1.ɵccf("app-error404", i2.Error404Component, View_Error404Component_Host_0, {}, {}, []);
export { Error404ComponentNgFactory as Error404ComponentNgFactory };
